<!-- partial/template for notifications -->
<template>
	<div class="kt-notification kt-margin-t-10 kt-margin-b-10 kt-scroll" data-scroll="true" data-height="300" data-mobile-height="200">
		<a v-for="(notification, index) in notifications" :key="index" v-bind:value="notification" href="#" v-bind:class="{'kt-notification__item': !notification.read_at,  'kt-notification__item kt-notification__item--read': notification.read_at}">
			<div class="kt-notification__item-icon">
				<i class="flaticon2-line-chart kt-font-success"></i>
			</div>
			<div class="kt-notification__item-details">
				<div class="kt-notification__item-title">
					{{ notification.data.message }}
				</div>
				<div class="kt-notification__item-time">
					{{ humanReadableTime(notification.created_at) }}
				</div>
			</div>
		</a>
		<a href="#" class="kt-notification__item kt-notification__item--read">
			<div class="kt-notification__item-icon">
				<i class="flaticon2-safe kt-font-primary"></i>
			</div>
			<div class="kt-notification__item-details">
				<div class="kt-notification__item-title">
					Company meeting canceled
				</div>
				<div class="kt-notification__item-time">
					19 hrs ago
				</div>
			</div>
		</a>
	</div>
</template>
<script>
import NotificationsAPIService from '@/js/api/notifications/notifications';
export default {
	name: 'notificationsList',
	data() {
        return {
			notifications:[],
		};
    },
	methods: {
    	getNotifications: function(e){

			var self = this;
			var usrToken = this.access_token;
			setTimeout(function(){
				NotificationsAPIService.getAll(usrToken).then((response) => {
					/**
					 * Assigning response data to local variables
					 */
					if(response.data !== 'undefined'){
						self.notifications = response.data.notifications;
					}
					setTimeout(function() {
					}, 3000);

				}).catch((error) => {
				});

			},2000);

  		}
    },
    mounted: function() {
		//this.getNotifications();
	}
};
</script>
